/* mega-menu.js — desktop mega panel + mobile push-panel drawer. A11y: ESC, focus trap. */
(function () {
  "use strict";

  // Mobile drawer
  const menu = document.querySelector("[data-mobile-menu]");
  const open = document.querySelector("[data-menu-toggle]");
  let release = null;

  // Multi-level push-panel state
  const panelsRoot = menu && menu.querySelector("[data-submenu-panels]");
  const backBtn = menu && menu.querySelector("[data-submenu-back]");
  const titleEl = menu && menu.querySelector("[data-submenu-title]");
  const rootName = titleEl ? titleEl.textContent : "";
  let stack = ["root"]; // panel id stack, last = current

  function panelById(id) {
    return panelsRoot && panelsRoot.querySelector('[data-panel="' + id + '"]');
  }
  function syncPanels() {
    if (!panelsRoot) return;
    const current = stack[stack.length - 1];
    panelsRoot.querySelectorAll("[data-panel]").forEach(function (p) {
      const id = p.getAttribute("data-panel");
      const depth = stack.indexOf(id);
      p.classList.toggle("is-active", id === current);
      // panels earlier in the stack sit to the left (already navigated past)
      p.classList.toggle("is-past", depth !== -1 && id !== current);
      p.style.zIndex = depth === -1 ? "" : String(depth + 1);
    });
    const currentPanel = panelById(current);
    if (backBtn) backBtn.hidden = stack.length <= 1;
    if (titleEl) titleEl.textContent = current === "root" ? rootName : (currentPanel && currentPanel.getAttribute("data-panel-title")) || rootName;
  }
  function pushPanel(id) {
    if (!panelById(id)) return;
    stack.push(id);
    syncPanels();
  }
  function popPanel() {
    if (stack.length > 1) stack.pop();
    syncPanels();
  }
  function resetPanels() {
    stack = ["root"];
    syncPanels();
  }

  function openMenu() {
    if (!menu) return;
    menu.hidden = false;
    resetPanels();
    requestAnimationFrame(function () {
      menu.setAttribute("aria-hidden", "false");
      menu.classList.add("is-open");
      if (open) open.setAttribute("aria-expanded", "true");
      if (window.Theme) release = window.Theme.trapFocus(menu);
    });
  }
  function closeMenu() {
    if (!menu) return;
    menu.setAttribute("aria-hidden", "true");
    menu.classList.remove("is-open");
    if (open) open.setAttribute("aria-expanded", "false");
    if (release) {
      release();
      release = null;
    }
    setTimeout(function () {
      menu.hidden = true;
      resetPanels();
    }, 250);
  }

  if (open) open.addEventListener("click", openMenu);
  document.addEventListener("click", function (e) {
    if (e.target.closest("[data-menu-close]")) {
      closeMenu();
      return;
    }
    const drill = e.target.closest("[data-submenu-open]");
    if (drill && menu && menu.contains(drill)) {
      e.preventDefault();
      pushPanel(drill.getAttribute("data-submenu-open"));
      return;
    }
    if (e.target.closest("[data-submenu-back]")) {
      e.preventDefault();
      popPanel();
    }
  });
  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape" || !menu || menu.getAttribute("aria-hidden") !== "false") return;
    // ESC steps back one level first, then closes at the root
    if (stack.length > 1) popPanel();
    else closeMenu();
  });

  // Desktop mega panels (hover + focus). Small close delay tolerates the
  // gap between the nav item and the panel so links stay clickable.
  document.querySelectorAll("[data-mega-item]").forEach(function (item) {
    const panel = item.querySelector("[data-mega-panel]");
    if (!panel) return;
    let closeTimer = null;
    function show() {
      if (closeTimer) {
        clearTimeout(closeTimer);
        closeTimer = null;
      }
      panel.hidden = false;
    }
    function hide() {
      panel.hidden = true;
    }
    function hideSoon() {
      if (closeTimer) clearTimeout(closeTimer);
      closeTimer = setTimeout(hide, 180);
    }
    item.addEventListener("mouseenter", show);
    item.addEventListener("mouseleave", hideSoon);
    item.addEventListener("focusin", show);
    item.addEventListener("focusout", function (e) {
      if (!item.contains(e.relatedTarget)) hide();
    });
  });
})();
